import { render, staticRenderFns } from "./ReplaceTag.vue?vue&type=template&id=09a12764"
import script from "./ReplaceTag.vue?vue&type=script&lang=js"
export * from "./ReplaceTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports